import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ colors }) => ({
  label: {
    color: colors.foregroundDefault,
    pointerEvents: "none",
    textAlign: "center",
    textTransform: "capitalize",
    _web: {
      cursor: "pointer",
    },
  },
  // TV keeps the default colour: its pill stays translucent, so nothing inverts.
  labelActive: {
    color: CustomPlatform.select({
      tv: colors.foregroundDefault,
      default: colors.foregroundOnInverted,
    }),
  },
}));

export default stylesheet;
